module.exports = __webpack_public_path__ + "static/media/leia.df6368bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/leia.jpg
// module id = 36
// module chunks = 0